import { render, staticRenderFns } from "./FornecedorBarChart.vue?vue&type=template&id=4421c2d3&scoped=true&"
import script from "./FornecedorBarChart.vue?vue&type=script&lang=js&"
export * from "./FornecedorBarChart.vue?vue&type=script&lang=js&"
import style0 from "./FornecedorBarChart.vue?vue&type=style&index=0&id=4421c2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4421c2d3",
  null
  
)

export default component.exports